import { useState, useEffect } from 'react';

interface AddressSuggestion {
  display_name: string;
  street: string;
  city: string;
  state: string;
  zip_code: string;
}

export function useAddressAutocomplete() {
  const [suggestions, setSuggestions] = useState<AddressSuggestion[]>([]);
  const [loading, setLoading] = useState(false);

  const searchAddress = async (query: string) => {
    if (query.length < 3) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`/api/customer/address-autocomplete?q=${encodeURIComponent(query)}`);
      const result = await response.json();
      
      if (result.success) {
        setSuggestions(result.data.suggestions);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Address autocomplete error:', error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const clearSuggestions = () => {
    setSuggestions([]);
  };

  return { suggestions, loading, searchAddress, clearSuggestions };
}